import { createSlice } from "@reduxjs/toolkit";
import type {

  TicketData,

} from "../../app/generated-axios-client";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface TicketDataItems {
  locations?: TicketData["locations"];
  clients?: TicketData["clients"];
  turbines?: TicketData["turbines"];
  blades?: TicketData["blades"];
  technicians?: TicketData["technicians"];
  coordinators?: TicketData["coordinators"];
  managers?: TicketData["managers"];
  projects?: TicketData["projects"];
  materials?: TicketData["materials"];
}
const initialState: TicketDataItems = {
  locations: undefined,
  clients: undefined,
  turbines: undefined,
  blades: undefined,
  technicians: undefined,
  coordinators: undefined,
  managers: undefined,
  projects: undefined,
  materials: undefined,
};

export const ticketDataSlice = createSlice({
  name: "ticketData",
  initialState,
  reducers: {
    addTicketData: (state, action: PayloadAction<TicketDataItems>) => {
      if ("clients" in action.payload) {
        state.clients = action.payload.clients;
      }
      if ("turbines" in action.payload) {
        state.turbines = action.payload.turbines;
      }
      if ("blades" in action.payload) {
        state.blades = action.payload.blades;
      }
      if ("technicians" in action.payload) {
        state.technicians = action.payload.technicians;
      }
      if ("coordinators" in action.payload) {
        state.coordinators = action.payload.coordinators;
      }
      if ("managers" in action.payload) {
        state.managers = action.payload.managers;
      }
      if ("locations" in action.payload) {
        state.locations = action.payload.locations;
      }
      if ("projects" in action.payload) {
        state.projects = action.payload.projects;
      }
      if ("materials" in action.payload) {
        state.materials = action.payload.materials;
      }
    },
    clearTicketDataClients: (state) => {
      state.clients = undefined;
    },
    clearTicketDataTurbines: (state) => {
      state.turbines = undefined;
    },
    clearTicketDataBlades: (state) => {
      state.blades = undefined;
    },
    clearTicketDataTechnicias: (state) => {
      state.technicians = undefined;
    },
    clearTicketDataCoordinators: (state) => {
      state.coordinators = undefined;
    },
    clearTicketDataManagers: (state) => {
      state.managers = undefined;
    },
    clearTicketDataLocations: (state) => {
      state.locations = undefined;
    },
    clearTicketDataProjects: (state) => {
      state.projects = undefined;
    },
    clearTicketDataMaterials: (state) => {
      state.materials = undefined;
    },
    clearTicketData: () => {
      return initialState;
    },
    fetchTicketData: (
      state,
      action: PayloadAction<Partial<Record<string, string>>>
    ) => {},
  },
});

export const ticketDataActions = ticketDataSlice.actions;
export default ticketDataSlice.reducer;
